import { Box } from "@mui/material"
import React, { useState } from "react"

import { s } from "../../utilities/common"
import { theme } from "../../utilities/theme"

export const PaginationButton = ({
  index,
  selected,
  onMouseDown,
  startIndex,
  disabled,
}: {
  index: number
  selected: boolean
  onMouseDown: () => void
  startIndex?: number
  disabled?: boolean
}) => {
  const [hovered, setHovered] = useState(false)

  return (
    <Box
      onMouseEnter={() => setHovered(!disabled)}
      onMouseLeave={() => setHovered(false)}
      onMouseDown={() => {
        if (!disabled) onMouseDown()
      }}
      sx={{
        ml: index > (startIndex ?? 0) ? s("16px") : 0,
        width: s("32px"),
        height: s("30px"),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          height: hovered ? "100%" : s("1.5px"),
          opacity: selected || hovered ? 1 : 0.25,
          background: theme.palette.tertiary.accentYellow,
          borderRadius: s("5px"),
        }}
      />
    </Box>
  )
}
